<template>
    <svg id="Camada_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.58 138.64">
        <path
            fill="#38bdf8"
            d="M38.11,126.3c-2.24,0-4.05-1.81-4.05-4.05,0-1.44-.03-2.91-.06-4.37-.16-8.24-.32-16.77,4.54-21.72,2.4-2.45,5.68-3.69,9.76-3.69,23.26,0,42.18-18.92,42.18-42.18S71.56,8.1,48.3,8.1c-18.72,0-34.94,12.02-40.37,29.91-.65,2.14-2.91,3.35-5.05,2.7-2.14-.65-3.35-2.91-2.7-5.05C6.65,14.33,25.99,0,48.3,0c27.73,0,50.28,22.56,50.28,50.28s-22.56,50.28-50.28,50.28c-2.74,0-3.67,.95-3.97,1.26-2.48,2.53-2.34,9.63-2.22,15.89,.03,1.51,.06,3.03,.06,4.53,0,2.24-1.81,4.05-4.05,4.05Z" />
        <circle fill="#38bdf8" cx="38.11" cy="135.14" r="3.5" />
    </svg>
</template>

<script setup>

</script>

<style>

</style>
